import { useState, useContext, useEffect } from "react";
import { RequestLoader, ToastContext } from "../../../hooks/context";
import { useNavigate } from "react-router-dom";
import { getRandomIntInclusive } from "../../../helpers";
import { useLoginSellModeMutation } from "../../../hooks/api/mutations/useAuth";
import { pathConstants } from "../../../routes/pathContants";
import { useGetProfileDetails } from "../../../hooks/api/queries/useSettings";
import useGrantAccessToApp from "../../../hooks/useGrantAccessToApp";

const SellModeAuthLogic = () => {
  const [cashierCode, setCashierCode] = useState("");
  const [businessAccessCode, setBusinessAccessCode] = useState(
    localStorage.getItem("businessCode") || "",
  );
  const triggerToast = useContext(ToastContext);
  const { setAuthTokensAndGrantAccessToApp } = useGrantAccessToApp({
    message: "Login Successful",
  });
  const navigate = useNavigate();
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const loginSellMode = useLoginSellModeMutation();

  const [tokens, setTokens] = useState({
    refreshToken: null,
    accessToken: null,
  });
  const { isLoading, data: profileDetails } = useGetProfileDetails({
    isProfileEnabled: tokens?.accessToken ? true : false,
    accessToken: tokens?.accessToken,
  });

  useEffect(() => {
    if (!isLoading && tokens?.refreshToken) getUserProfileDetails();
  }, [isLoading, tokens]);

  const cashierlogin = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    loginSellMode.mutate(
      {
        code: cashierCode,
        business_id: businessAccessCode,
      },
      {
        onSuccess: (res) => {
          const { access, refresh } = res?.data;
          setTokens({
            refreshToken: refresh,
            accessToken: access,
          });
        },
        onSettled: () => setRequestLoaderProgress(100),
      },
    );
  };

  const getUserProfileDetails = () => {
    if (!profileDetails.email_verified) {
      triggerToast("Please verify your email", "warning");
      return navigate(pathConstants.SELLMODE_AUTH);
    }

    localStorage.setItem("businessCode", businessAccessCode);
    setAuthTokensAndGrantAccessToApp({
      refreshToken: tokens?.refreshToken,
      accessToken: tokens?.accessToken,
      profileDetails: profileDetails,
    });
  };

  return {
    cashierCode,
    businessAccessCode,
    isLogging: loginSellMode.isLoading,
    cashierlogin,
    setCashierCode,
    setBusinessAccessCode,
    navigate,
  };
};
export default SellModeAuthLogic;
